import { deepKeysToSnake } from '@eb/transformation-utils';
import { sdkRequest } from '@eb/http';
import { formatUrl } from 'url-lib';

import { pruneObject } from '../utils';

const GET_PLACE_FROM_GOOGLE_PLACE_ID_URL =
    '/api/v3/geo/place_from_google_place_id/';

export const getPlaceFromGooglePlaceId = (googlePlaceId) => {
    const queryParams = deepKeysToSnake(
        pruneObject({
            googlePlaceId,
        }),
    );

    return sdkRequest(
        formatUrl(GET_PLACE_FROM_GOOGLE_PLACE_ID_URL, queryParams),
    );
};
